/* eslint-disable react/no-unknown-property */
import { Html } from '@react-three/drei';
import { PuffLoader } from 'react-spinners';

interface SatelliteModalProps {
  selectedSatellite: any;
  isLoading: boolean;
  scheduleData: any[];
  onClose: () => void;
}

const SatelliteModal = ({ selectedSatellite, isLoading, scheduleData, onClose }: SatelliteModalProps) => {
  if (!selectedSatellite) return null;

  return (
    <Html 
      position={[selectedSatellite.position.x + 2, selectedSatellite.position.y + 2, selectedSatellite.position.z]}
    >
      <div className="bg-white border border-gray-300 rounded-lg p-4 shadow-lg min-w-[420px] max-w-[500px]">
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-lg font-bold text-gray-800">{selectedSatellite.name}</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>
        
        {isLoading ? (
          <div className="flex flex-col justify-center items-center h-20 space-y-2">
            <PuffLoader color="#4a90e2" size={30} />
            <span className="text-gray-600 text-sm">Loading the schedule...</span>
          </div>
        ) : scheduleData.length > 0 ? (
          <div className="space-y-2">
            {scheduleData.map((schedule, idx) => (
              <div key={idx} className="text-sm border-b border-gray-200 pb-2">
                <div className="grid grid-cols-2 gap-x-6">
                  <span className={`font-medium ${schedule.isDisabled ? 'text-red-500' : 'text-black'}`}>
                    AOS: {schedule.startTime}
                  </span>
                  <span className={`font-medium ${schedule.isDisabled ? 'text-red-500' : 'text-black'}`}>
                    LOS: {schedule.endTime}
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-x-6 text-gray-600">
                  <span className={schedule.isDisabled ? 'text-red-500' : ''}>
                    MaxElevation: {schedule.maxElevation}
                  </span>
                  <span className={schedule.isDisabled ? 'text-red-500' : ''}>
                    Duration: {schedule.duration}
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-sm">There is no schedule for today.</p>
        )}
      </div>
    </Html>
  );
};

export default SatelliteModal;
